import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { BasicInfo } from '../../models/BasicInfo';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { postUtagEvent, UTAG_EVENT_JSON } from '../../../public/utag';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { SettlementContractRequest } from '../../service/service-models/settlement/SettlementContractRequest';
import { SettlementContractResult } from '../../service/service-models/settlement/SettlementContractResult';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { PaymentInfo } from '../../service/models/payment/payment-info';
import { LoginInfo } from '../../models/LoginInfo';
import { PolicyHolderInfo } from '../../service/models/policy-holder/policy-holder-info';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { InsuredInfo } from '../../service/models/insured/insured-info';
import { PolicyContractInfo } from '../../service/models/policy-contract/policy-contract-info';
import { SettlementService } from '../../service/SettlementService';
import { AuthMailInfo } from '../../service/models/auth-mail/auth-mail-info';
import { CollateralInfo } from '../../models/CollateralInfo';
import { TravelerInfo } from '../../models/TravelerInfo';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { ContractorInfo } from '../../models/ContractorInfo';
import { OthersInfo } from '../../models/OthersInfo';
import { PlanInfo } from '../../models/PlanInfo';
import { SpecialProvision } from '../../models/SpecialProvision';
import Encoding from 'encoding-japanese';

/** PayPay返却HTMLコンテンツ */
export let paypayHtmlContents: HTMLElement;
export let paypayScripts: HTMLCollectionOf<Element>;
export let paypayHtmlMetaData: HTMLCollectionOf<Element>;
export let paypayBodyAttribure: NamedNodeMap;

/**
 * 支払い選択ビュー情報
 */
export class SelectPaymentComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// モデル -------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode:		string 				= null;
	@WprDI_ScopeModel('BasicInfo')
	@WprModel('BasicInfo')
	private m_BasicInfo: 		BasicInfo			= null;	// 基本情報
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo:	RiskFactorInfo 		= null;	// リスクファクター情報
	@WprDI_ScopeModel('SelectPlanInfo')
	private m_SelectPlanInfo: 	SelectPlanInfo		= null;	// 選択プラン情報
	@WprDI_ScopeModel('LoginInfo')
	private m_LoginInfo: 		LoginInfo 	 		= null; // ログイン情報
	@WprDI_ScopeModel('PolicyHolderInfo')
	private m_PolicyHolderInfo: PolicyHolderInfo 	= null; // 契約者情報（サービス）
	@WprDI_ScopeModel('InsuredInfoList')
	private m_InsuredInfoList: 	InsuredInfo[]		= null; // 旅行者リスト情報（サービス）
	@WprDI_ScopeModel('AuthMailInfo')
	private m_AuthMailInfo: 	AuthMailInfo 		= null; // 契約者（申込者）情報
	@WprDI_ScopeModel('TravelerInfo')
	private m_TravelerListInfo: TravelerInfo[] 			= null; 					// 旅行者（被保険者）リスト情報
	@WprDI_ScopeModel('ContractNoticeInfo')
	private m_ContractNoticeList: ContractNoticeInfo[] 	= null; 					// 告知事項情報
	@WprDI_ScopeModel('CollateralInfo')
	private m_Collaterals: CollateralInfo[] 			= null;						// 補償表示情報
	@WprDI_ScopeModel('PlanInfo')
	private m_PlanInfo: PlanInfo 						= null;						// プラン情報 
	@WprDI_ScopeModel('SpecialProvision')
	private m_SpecialProvision: SpecialProvision 		= null; 					// 特約・約款情報
	@WprDI_ScopeModel('ContractorInfo')
	private m_ContractorInfo: ContractorInfo 			= null; 					// 契約者（申込者）情報
	@WprDI_ScopeModel('OthersInfo')
	private m_OthersInfo: OthersInfo 					= null; 					// その他情報
	@WprDI_ScopeModel('payment')
	private m_Payment:string							= null;						// 支払い方法
	@WprDI_ScopeModel('paymentType')
	private m_PaymentType:string						= null;						// 支払種別
	@WprDI_GlobalScopeModel('AuthMailId')
	private m_AuthMailId: string						= null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('step7_payment');
	}
	// --------------------------------------------------------------------------

	// サービス  -----------------------------------------------------------------
	private m_SettlementService: SettlementService = new SettlementService(); // 締結サービス
	// --------------------------------------------------------------------------
	
	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('insuranceFee', '合計保険料', 'BasicInfo');
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		super.onRegisterAction();
		this.addAction('creditButton',		this.onCredit);
		this.addAction('paypayButton',		this.onOpenModal);
		this.addAction('closeButton',		this.onCloseModal);
		this.addAction('settlementButton',	this.onPayPay);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		this.onUtagView();
		this.refreshModel();
		this.refreshView();
	}

	/**
	 * Tealium Event Tag 
	 * @param param 
	 */
	public setUtagEvent(param:string, value:any): void{
		const cat = UTAG_EVENT_JSON[0].select_payment;
		const ev = UTAG_EVENT_JSON[1].ev_click;
		const evVal = UTAG_EVENT_JSON[2].ev_value;
		if(param === 'creditButton'){
			postUtagEvent(cat, ev, 'payment_credit', evVal);
			this.setScopeModel('payment', 'payment_credit');
		}
		else {
			postUtagEvent(cat, ev, 'payment_paypay', evVal);
			this.setScopeModel('payment', 'payment_paypay');
		}
		// console.log('UtagEvent: '+cat);
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------
	
	// アクション  ---------------------------------------------------------------	    
	/**
	 * クレジット払い画面へ遷移
	 * @param param 
     */
	public onCredit(param: any): void {
		this.setUtagEvent(param, null);
		this.setScopeModel('paymentType', 'CC');
		this.pushPath('/step7_creditcard');
	}

	/**
     * Paypayサイトへ遷移
     * @param param 
     */
	public onPayPay(param: any): void {
		this.setUtagEvent(param, null);
		const req = this.setSettlementReq('IC', 'PayPay');
		this.m_SettlementService.requestAuthPayPay(this, req, (result) =>{
			const authRes: SettlementContractResult = result as SettlementContractResult;
			this.m_LoginInfo.loginId = authRes.bookingNo;
			const orderId: string = authRes.paypayOrderId;
			const custTxn: string = authRes.paypayCustTxn;
			this.refreshModel();
			if (result.paypayRedirectUrl !== null) {
				const parser: DOMParser = new DOMParser();
				const doc = parser.parseFromString(result.paypayRedirectUrl, 'text/html');
				const headElement = doc.getElementsByTagName('META');
				if (headElement)
					paypayHtmlMetaData = headElement;
				const scripts = doc.scripts;
				if (scripts)
					paypayScripts = scripts;
				paypayHtmlContents = doc.body;
				const bodyAttrNames = doc.body.getAttributeNames();
				paypayBodyAttribure = doc.body.attributes;
				req.paypayCustTxn = custTxn;
				req.paypayOrderId = orderId;
				req.bookingNo = authRes.bookingNo;
				this.FW.view.addViewStack('/step7_paypay');
				this.pushPath('/step7_paypay');
			}
		});
	}

	/**
     * モーダル表示処理
     * @param param 
     */
	public onOpenModal(param: any): void {
		this.setViewMode('PayPayModalMode', param);
	}

	/**
     * モーダルを閉じる
     * @param param 
     */
	public onCloseModal(param: any): void {
		this.setViewMode('PayPayModalMode', '');
	}
	// --------------------------------------------------------------------------

	// private ------------------------------------------------------------------
	/**
	 * SettlementConotractReq設定
	 * （PayPayの場合　→　PaymentInffo：paymentTypr・paymentmethodのみ。）
	 */
	private setSettlementReq(paymentType: string, paymentMethod: string): SettlementContractRequest{
		const req: SettlementContractRequest = new SettlementContractRequest();
		// const today = String(new Date());
		const today = this.m_AuthMailInfo.applicationDate;
		req.transactionDate 	= today.replace(/(\d+)\/(\d+)\/(\d+)/g, '$1-$2-$3');
		req.riskFactorInfo 		= this.m_RiskFactorInfo;
		req.selectPlanInfo 		= this.m_SelectPlanInfo;
		req.policyContractInfo 	= new PolicyContractInfo();
		req.policyContractInfo.policyHolderInfo = this.m_PolicyHolderInfo;
		req.policyContractInfo.insuredInfoList 	= this.m_InsuredInfoList;
		req.paymentInfo 		= new PaymentInfo();
		req.paymentInfo.paymentType		= paymentType;
		this.m_PaymentType				= paymentType;
		this.setScopeModel('paymentType', paymentType);
		req.paymentInfo.paymentMethod 	= paymentMethod;
		req.inquiryPassword 			= this.m_LoginInfo.loginPass;
		req.authMailId					= this.m_AuthMailId;
		return req;
	}
	// --------------------------------------------------------------------------
}